import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L, performAction } from '@nu-art/thunderstorm-frontend/index';
import './ErrorPage_Values.scss';
import { QToastContent } from '../q-components/index.js';
import { resolveValueDisplay } from '@app/hcs-shared/core';
import { ModuleFE_Value } from '../../_entity/value/index.js';
export class ErrorPage_Values extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.value = ModuleFE_Value.cache.unique(nextProps.valueId);
        state.error = nextProps.error;
        return state;
    }
    renderErrorParagraph = () => {
        return _jsxs("p", { children: ["Value \"", resolveValueDisplay(this.state.value), "\" is a floating value, meaning it is not connected to any parent value or variable. Consider deleting this value."] });
    };
    renderDeleteButton = () => {
        return _jsx(Button, { variant: 'dangerous', onClick: async () => {
                await performAction(async () => {
                    await ModuleFE_Value.v1.delete(this.state.value).executeSync();
                }, {
                    type: 'toast',
                    successContent: _jsx(QToastContent, { toastType: 'success', iconKey: 'v', content: 'Value Deleted Successfully' }),
                    duration: 10000
                }, resolveValueDisplay(this.state.value));
            }, children: "Delete Value" });
    };
    renderError = () => {
        if (!this.state.error)
            return;
        return _jsxs("details", { children: [_jsx("summary", { children: "Error Details" }), _jsx("p", { children: this.state.error.message })] });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'error-page__values', children: [this.renderErrorParagraph(), this.renderDeleteButton(), this.renderError()] });
    }
}
//# sourceMappingURL=ErrorPage_Values.js.map